import React, {useEffect, useState} from 'react';
import ReactDOM from "react-dom";
import CloseIcon from "components/style-guide/icons/Close.icon";
import {chileCurrency} from "shared";
import AppRouters from "settings/app-routers";
import 'moment/locale/es';
import {Link} from "@reach/router";
import {useOffers} from "hooks/useOffers";

import styles from './offers.module.scss';

export const Offers = ({promotions = []}) => {
    const [show, setShow] = useState(false);
    const [promotion] = promotions;
    const {offerPrice} = useOffers();

    useEffect(() => {
        setTimeout(() => {
            setShow(true);
        }, 3000)
    }, [])

    if (!promotion || !show) return <div/>;   

    return ReactDOM.createPortal(
        <>
            <div className={styles.modalOverlay}/>
            <div className={styles.body}>
                     <span className={styles.modalCloseButton} data-dismiss="modal" aria-label="Close">
                        <CloseIcon
                            className="inline-icon close-modal-icon"
                            stroke='black'
                            onClick={() => setShow(false)}/>
                      </span>
                <div className={styles.content}>
                    <div>
                        <h4>{promotion.titulo}</h4>
                        <p>{promotion.detalles}</p>
                    </div>
                    <div>
                        -{promotion.descuento}%
                    </div>
                    <div>
                        <p>{promotion.descripcion}</p>
                        <h4>{chileCurrency(offerPrice)}</h4>
                        <Link to={AppRouters.newReport} className="btn btn-primary form-control">
                            Solicitar Reporte
                        </Link>
                    </div>
                </div>
            </div>
        </>,
        document.getElementById('modal-root')
    );
};
